import $ from 'jquery';
import { scrollToTopOfElement } from '../utilities.js';
import {
  getTotalIMSIncentives,
  updateTotalPrice,
  getCostOfBorrowing,
  formatList,
} from './showroom-utilities.js';
import { Formatter, PaymentCalculatorFactory } from '@dealersites/dealersite-js-core';
import { __ } from '@wordpress/i18n';

const configurePage = $('#configure-container-FLP');

if (configurePage.length !== 0) {
  const $configureOptions = $('.configure-options');
  const $configureColorOptions = $('.configure-color-options');
  const $optionChecks = $('.OptionsCheckbox input');
  const bottomBarBtnNext = $('.BottomBarBtnNext-FLP a');
  const bottomBarTotal = $('.bottom-bar--total');
  const $configureModalBtn = $('.js-open-configure-modal');
  const $configureLoader = $('.configure-loader');
  const $configureTotal = $('.js-total-price');
  const configureRow = $('.ConfigureRow');
  const $configureUpdateable = $('.configUpdate');
  const provinceCode = configureRow.data('provinceCode');
  const styleId = configureRow.data('styleId');
  const $selectedOptionsGroup = $('.js-selected-options-group');
  const $selectedOptions = $('.js-selected-options');
  const $configurations = $('.js-configurations');
  const defaultConfiguredTotal = $configurations.data('total');
  const exciseTax = $configurations.data('excise');
  const baseURL = '/showroom/_configure';
  const formOptions = $('.bottom-form .dsp_dynamic_options textarea');
  const formPrice = $('.bottom-form .dsp_dynamic_price input');

  let configToken = configurePage.data('configToken');
  let status = '';
  let isFullyConfigured = true;

  const $financePayment = $('#bottom-bar--finance .finance');
  const $leasePayment = $('#bottom-bar--lease .lease');

  let configChecklist = [];
  let configuredTotal = defaultConfiguredTotal + exciseTax;

  const configureSticky = $('#configure-sticky-overview');

  // Observe Sticky
  const sectionOne = document.querySelector('.configure-bottom-bar');

  const observeOptions = {};

  const configObserver = new IntersectionObserver(function (entries, observer) {
    if (!entries[0].isIntersecting) {
      // show the sticky
      configureSticky.removeClass('inactive');
    } else {
      // hide the sticky
      configureSticky.addClass('inactive');
    }
  }, observeOptions);

  configObserver.observe(sectionOne);

  /**
   * Toggles the loading screen on and off depending on
   * the boolean value presented.
   *
   * @param {boolean}        active
   */

  function toggleLoadingScreen(active) {
    if (active) {
      bottomBarBtnNext.prop('disabled', true).addClass('opacity-0').addClass('pointer-events-none');
      $configureOptions.addClass('blocked');
      $configureColorOptions.addClass('blocked');
      $configureModalBtn
        .prop('disabled', true)
        .addClass('opacity-0')
        .addClass('pointer-events-none');
      $configureTotal.addClass('opacity-0');
      $configureUpdateable.addClass('opacity-0');
      $configureLoader.each(function () {
        $(this).removeClass('inactive');
      });

      return;
    }

    $configureTotal.removeClass('opacity-0');
    $configureUpdateable.removeClass('opacity-0');
    $configureOptions.removeClass('blocked');
    $configureColorOptions.removeClass('blocked');
    bottomBarBtnNext
      .prop('disabled', false)
      .removeClass('opacity-0')
      .removeClass('pointer-events-none');
    $configureModalBtn
      .prop('disabled', false)
      .removeClass('opacity-0')
      .removeClass('pointer-events-none');
    $configureLoader.each(function () {
      $(this).addClass('inactive');
    });
  }

  function updatePayments(updatedConfiguredPrice = null) {
    if ($financePayment.length) {
      $financePayment.each(function (index) {
        /* on initial page load */
        let currentPrice = $(this).data('price');
        const frequency = $(this).data('frequency');
        const cob = $(this).data('cob');

        /* check if a configuration change has been made */
        if (updatedConfiguredPrice) {
          const totalFinanceIncentives = getTotalIMSIncentives('finance');
          currentPrice = updatedConfiguredPrice - totalFinanceIncentives;
        }

        let calcInputs = {
          price: currentPrice,
          down: $(this).data('down'),
          term: $(this).data('term'),
          rate: $(this).data('rate'),
          tradein: $(this).data('tradein'),
          tax: 0,
        };

        const financeCalc = PaymentCalculatorFactory.createCalculator('finance', calcInputs);
        financeCalc.calculate();
        const paymentAmount = financeCalc.payments[frequency];
        $(this).text(Formatter.price(paymentAmount, 2));

        if (cob) {
          const $cobElemF = $(this).closest('.dsp-payment').find('.dsp-cob');
          const financeCOB = getCostOfBorrowing({
            payment: paymentAmount,
            term: calcInputs.term,
            frequency: frequency,
            price: currentPrice,
          });

          $cobElemF.text(Formatter.price(financeCOB), 2);
        }
      });
    }

    if ($leasePayment.length) {
      $leasePayment.each(function (index) {
        /* on initial page load */
        let currentPrice = $(this).data('price');
        const frequency = $(this).data('frequency');
        const cob = $(this).data('cob');

        /* check if a configuration change has been made */
        if (updatedConfiguredPrice) {
          const totalLeaseIncentives = getTotalIMSIncentives('lease');
          currentPrice = updatedConfiguredPrice - totalLeaseIncentives;
        }

        let calcInputs = {
          price: currentPrice,
          term: $(this).data('term'),
          rate: $(this).data('rate'),
          residual: $(this).data('residual'),
          tax: 0,
        };

        const leaseCalc = PaymentCalculatorFactory.createCalculator('lease', calcInputs);
        leaseCalc.calculate();
        const paymentAmount = leaseCalc.payments[frequency];
        $(this).text(Formatter.price(paymentAmount, 2));

        if (cob) {
          const $cobElemL = $(this).closest('.dsp-payment').find('.dsp-cob');
          const leaseCOB = getCostOfBorrowing({
            payment: paymentAmount,
            term: calcInputs.term,
            frequency: frequency,
            price: currentPrice - calcInputs.residual,
          });

          $cobElemL.text(Formatter.price(leaseCOB), 2);
        }
      });
    }
  }

  /**
   * Creates an AJAX request to fetch Chrome Data. If Configuration Token is null
   * the request will automatically return one. If both Configuration Token and
   * Option Codes are present, the request will return an object with a new Configuration
   * Token and all the Chrome Data relevant for the current configuration.
   *
   * @param {string|null}        configurationToken
   * @param {string|null}        optionCode
   *
   * @returns {Object}
   */
  function requestChromeData(configurationToken = null, optionCode = null) {
    toggleLoadingScreen(true);

    const styleIdQuery = `?style_id=${styleId}`;
    const configQuery =
      configurationToken === null ? '' : `&configuration_token=${configurationToken}`;
    const optionQuery = configQuery.length > 0 ? `&option_code=${optionCode}` : '';
    const requestURL = `${baseURL}${styleIdQuery}${configQuery}${optionQuery}`;

    $.ajax({
      type: 'GET',
      url: requestURL,
      success: function (res) {
        const configuration = res.data;
        configToken = configuration.configuration_token;
        status = configuration.status;

        if (status === 'UserChoiceNeeded') {
          let inputOptions = {};
          if (configuration.optional_equipment) {
            configuration.optional_equipment.forEach(function (option) {
              inputOptions[option.chrome_option_code] = option.primary_name;
            });
          }
        } else {
          // No conflict
          if (configuration.optional_equipment) {
            configuration.optional_equipment.forEach((option) => {
              const $optionEl = $(`#${option.chrome_option_code}`);
              const optionWasChecked = $optionEl.hasClass('checked');

              switch (option.selection_state) {
                case 'Selected':
                case 'Included':
                case 'Required':
                  $optionEl.addClass('checked');
                  $optionEl.prop('checked', true);
                  $optionEl.parent('.OptionsAccessoriesInput').removeClass('opacity-50');
                  break;
                case 'Unselected':
                case 'Excluded':
                case 'Upgraded':
                  if (optionWasChecked) {
                    $optionEl.prop('checked', false);
                    $optionEl.removeClass('checked');
                  }
                  break;
              }

              // Visually indicate to user if the next option they select will be compatible or
              // will change one or more options they've already selected.
              // i.e.
              // 1. User selected 'TWO-Tone Paint' option
              // 2. User should see that if they now select a 'ONE-Tone Colour: Black',
              // this will impact their current configuration e.g. remove 'TWO-Tone Paint'
              if (
                option.selection_state === 'Excluded'
                // || option.selection_state === 'Upgraded'
              ) {
                $optionEl.parent('.OptionsAccessoriesInput').addClass('opacity-50');
              } else {
                $optionEl.parent('.OptionsAccessoriesInput').removeClass('opacity-50');
              }
            });

            $selectedOptions.empty();
            populateSelectionList();
          }
        }

        isFullyConfigured = configuration.fully_configured;
        configChecklist = configuration.configuration_check_list_items;
        /* provides only the total_msrp (includes freight), but must re-apply the Excise Tax Manually  */
        configuredTotal = configuration.total_msrp + exciseTax;
        const optionsMSRP = configuration.options_msrp;
        // console.log(optionsMSRP);
        $selectedOptionsGroup.attr('data-options-msrp', optionsMSRP);

        // console.log('configuredTotalAfterPurchaseORChange (with Tax)', configuredTotal );
        updateTotalPrice(configuredTotal, bottomBarTotal, 'cash', formPrice);
        updatePayments(configuredTotal);
        updateNextButton(configuration.configuration_token);
        toggleLoadingScreen(false);
      },
      error: function () {
        toggleLoadingScreen(false);
      },
      dataType: 'json',
    });
  }

  /**
   * Takes in an array of images to create new slides from Chrome Data.
   *
   * @param {array}        imageUrlList
   */

  /**
   * To avoid having a huge amount of modals with all possible images in the twig
   * file and possibly increase loading times, this function will create a modal
   * with a src (image) and an id (imageId). Each time a new set of exterior
   * images are loaded (See function createSlides), a new modal is created for
   * each of those images to go with it.
   *
   * @param {string}        imageSource
   * @param {string}        imageId
   */

  /**
   * Takes in the status of the current user configuration and the
   * Configuration Token to create a button for the next step in the
   * B&P. If the current configuration requires user action, the button
   * will be disabled.
   *
   * @param {string}        status
   * @param {string}        configToken
   */
  function updateNextButton(configToken) {
    const href = `/showroom/summary/${styleId}?province_code=${provinceCode}&configuration_token=${configToken}`;

    if (isFullyConfigured) {
      bottomBarBtnNext.attr('href', href).removeClass('disabled CustomDisabledButton');
      return;
    }

    bottomBarBtnNext
      .removeAttr('href')
      .attr('aria-disabled', 'true')
      .addClass('disabled CustomDisabledButton');
  }

  /**
   * Handles when a user selects an option
   * 1. Makes request to chromedata to check configuration
   * 2. Prompts user of any additional input required from them
   * 3. Updates image slider if option toggled is an exterior color (chromedata does not provide interior images)
   *
   * @param optionCode
   */
  function handleOptionSelection(optionCode) {
    if (!optionCode) {
      console.warn(__('Option code is missing!'));
      return;
    }
    requestChromeData(configToken, optionCode);
  }

  function toggleDescription(description) {
    let closed = description.hasClass('text-truncate');

    description.find('.OptionReadMore').on('click', function () {
      description.toggleClass('text-truncate');
      closed = !closed;
      return closed ? $(this).text(__('Read more')) : $(this).text(__('Read less'));
    });
  }

  function populateSelectionList() {
    $selectedOptions.empty();
    const selectedConfiguration = [];
    const allConfiguration = [];
    let hasConfigurations = false;

    $optionChecks.each(function () {
      const isChecked = $(this).prop('checked');
      if (isChecked) {
        const msrp = $(this).data('msrp');
        const code = $(this).data('option-code');

        if (msrp != 0 && code != '-EXTAX') {
          hasConfigurations = true;
          selectedConfiguration.push({
            primary_name: $(this).data('label'),
            msrp: msrp,
          });
        }
        if (code != '-EXTAX') {
          allConfiguration.push({
            primary_name: $(this).data('label'),
            msrp: msrp,
          });
        }
      }
    });

    if (selectedConfiguration.length) {
      selectedConfiguration.forEach((opt) => {
        $selectedOptions.append(
          `<div class="price-item"> 
              <div class="price-item__title"> ${opt.primary_name} </div> 
              <div class="price-item__value"> 
                <span>${Formatter.price(opt.msrp, 2)}</span>
              </div>
              <div class="theme-bar-rounded"></div>
          </div>`,
        );
      });
    }

    if (allConfiguration.length) {
      formOptions.val(formatList(allConfiguration));
    }

    if (hasConfigurations) {
      $selectedOptionsGroup.removeClass('inactive');
    } else {
      $selectedOptionsGroup.addClass('inactive');
    }
  }

  // Configure Initializations
  $('.OptionDescription').each(function () {
    toggleDescription($(this));
  });

  populateSelectionList();
  updateNextButton(configToken);
  setTimeout(() => {
    toggleLoadingScreen(false);
  }, 2000);
  updatePayments();

  // Event Handlers
  $('.OptionsAccessoriesInput').on('click', function () {
    // If input is type radio means one from its group must be selected
    // If already selected, no need to toogle value.
    // Also if is the only of the group, no need to toogle value.
    const $input = this.querySelector('input');
    let inputType = $input.getAttribute('type');
    let isChecked = $input.classList.contains('checked');

    if (isChecked && inputType === 'radio') {
      return;
    }
    const optionCode = $input.getAttribute('data-option-code');
    handleOptionSelection(optionCode);
  });

  $('.BottomBarBtnNext-FLP').on('click', function () {
    if ($('.CustomDisabledButton').length > 0) {
      $('.OptionsAccessories .collapse-nav').removeClass('unsatisfied');
      let unsatisfiedList = configChecklist.filter((item) => item.satisfied == false);
      if (unsatisfiedList.length) {
        const firstItem = unsatisfiedList[0];
        const firstCode = firstItem.chrome_option_codes[0];
        const $group = $(`#${firstCode}`).parents('.collapse-nav');
        scrollToTopOfElement($group);
        if (!$group.hasClass('is-active')) {
          $group.find('.collapse-link').trigger('click');
        }
        $group.addClass('unsatisfied');
        $group.find('.OptionsAccessoriesInput').addClass('animate-pulse');
        setTimeout(() => {
          $group.find('.OptionsAccessoriesInput').removeClass('animate-pulse');
        }, 5000);
      }
    }
  });

  $('.js-targeted-incentive').on('change', function () {
    updateTotalPrice(configuredTotal, bottomBarTotal, 'cash', formPrice);
    updatePayments(configuredTotal);
  });
}
